// CSS Modules - component class name prefix: ContentTeaserS__

<template>
  <figure :class="$style.container">
    <a
      v-if="isVideo"
      :class="[$style.mediaLink, $style.videoLink]"
      @click="
        isModalOpen = true;
        wtParams &&
          wtTrack(
            { cat: wtParams.doctype },
            mergeWtParams(
              wtParams,
              {
                filename: primaryLink
              },
              {}
            )
          );
      "
      aria-label="goto detail"
    >
      <i class="fab fa-youtube"></i>
      <img :src="image" :alt="linkTitle" />
    </a>
    <a
      v-if="!isVideo"
      :class="$style.mediaLink"
      :href="primaryLink"
      :target="primaryLinkNewWindow ? '_blank' : '_self'"
      @click="
        wtParams &&
          wtTrack(
            { cat: wtParams.doctype },
            mergeWtParams(
              wtParams,
              {
                filename: primaryLink
              },
              {}
            )
          )
      "
    >
      <img :src="image" alt="" />
    </a>
    <figcaption>
      <a
        v-if="category"
        :class="$style.secondaryLink"
        :href="secondaryLink"
        :target="secondaryLinkNewWindow ? '_blank' : '_self'"
      >
        {{ category }}
      </a>
      <a
        v-if="isVideo && linkTitle"
        :class="$style.primaryLink"
        @click="
          isModalOpen = true;
          wtParams &&
            wtTrack(
              { cat: wtParams.doctype },
              mergeWtParams(
                wtParams,
                {
                  filename: primaryLink
                },
                {}
              )
            );
        "
      >
        {{ linkTitle }}
      </a>
      <a
        v-if="!isVideo && linkTitle"
        :class="$style.primaryLink"
        :href="primaryLink"
        :target="primaryLinkNewWindow ? '_blank' : '_self'"
        @click="
          wtParams &&
            wtTrack(
              { cat: wtParams.doctype },
              mergeWtParams(
                wtParams,
                {
                  filename: primaryLink
                },
                {}
              )
            )
        "
      >
        {{ linkTitle }}
      </a>
    </figcaption>
    <Modal v-if="isVideo" :isModalOpen="isModalOpen" :isVideo="isVideo" @closeModal="isModalOpen = false">
      <iframe v-if="isModalOpen" :src="primaryLink" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </Modal>
  </figure>
</template>

<script>
import Modal from "../Modal/Modal.vue";
import { mergeSwitchWtParams } from "../../utils/tracking";

export default {
  name: "ContentTeaserS",
  components: {
    Modal
  },
  props: {
    isVideo: {
      type: Boolean,
      default: false
    },
    primaryLink: {
      type: String,
      default: ""
    },
    primaryLinkNewWindow: {
      type: Boolean,
      default: true
    },
    secondaryLink: {
      type: String,
      default: ""
    },
    secondaryLinkNewWindow: {
      type: Boolean,
      default: true
    },
    category: {
      type: String,
      default: ""
    },
    linkTitle: {
      type: String,
      default: ""
    },
    image: {
      type: String,
      default: ""
    },
    wtParams: Object
  },
  methods: {
    mergeWtParams(globalWtParams, itemWtParams, itemParams) {
      return mergeSwitchWtParams(globalWtParams, itemWtParams, itemParams);
    }
  },
  data() {
    return {
      isModalOpen: false
    };
  }
};
</script>

<style module lang="scss">
@import "./ContentTeaserS.scss";
</style>
